import { HttpParams } from '@angular/common/http';
import { typedEntries } from './typed-entries';
import { QueryList } from '@angular/core';
import { FormFieldList, SmartFormComponent } from 'ngx-smart-form';
import {
  tap,
  startWith,
  combineLatest,
  map,
  skipWhile,
  Observable,
} from 'rxjs';
import { PraticaSection } from '../pratica/models/pratica-section';
import { FormGroup, FormControl } from '@angular/forms';
import { FormType } from 'ngx-smart-form/lib/smart-form/types/form-type';

type ParamsObject = Record<string, string | boolean | number | object | null>;

export const genHttpParams = <P extends ParamsObject>(filter?: P) => {
  if (!filter) {
    return new HttpParams();
  }
  let entries = typedEntries<ParamsObject>(filter);
  let params = new HttpParams();
  entries.forEach(([key, value]) => {
    /* if (key === 'statiPratica' && value && Array.isArray(value)) {
      value.forEach((el) => {
        params = params.set(key, el);
      });
    } else */ if ((value || value === 0) && key !== 'piva') {
      let newParamValue = '';
      if (typeof value === 'string') {
        newParamValue = value;
      } /* else if (Array.isArray(value)) {
        newParamValue = `[${value.join(',')}]`;
      } */ else {
        newParamValue = value.toString();
      }
      params = params.set(key, newParamValue);
    }
  });
  return params;
};

export const getValidFieldsFormValue = (
  formComponentList?: QueryList<SmartFormComponent>,
  expungeJustUploadedDocuents = false
) => {
  let formValue: any = {};
  formComponentList?.forEach((c) => {
    Object.entries(c.form.controls)
      .filter(([key, control]) => {
        if (!expungeJustUploadedDocuents) {
          return control.valid || control.disabled;
        } else {
          return (control.valid || control.disabled) && control.value?.id;
        }
      })
      .forEach(([key, control]) => {
        formValue[key] = control.value;
      });
  });
  return formValue;
};

export const trackFormChanges = <T = any>(
  componentList: SmartFormComponent<T>[]
) => {
  const progressList$ = componentList.map((c) =>
    c.form.valueChanges.pipe(startWith(undefined))
  );
  const fieldList = componentList.map((c) => c.fields.flat());
  const formList = componentList.map((c) => c.form);
  return getCompletionPercentage(progressList$, /* fieldList, */ formList);
};

export const validateShadowForm = <T>(
  fields: FormFieldList<T>,
  formValue: T
) => {
  let shadowForm = new FormGroup({});
  fields.flat().forEach((field) => {
    shadowForm.addControl(
      field.formControlName,
      new FormControl(
        { value: formValue[field.formControlName], disabled: field.disabled },
        field.validators
      )
    );
  });
  return getCompletionPercentage(
    [shadowForm.valueChanges.pipe(startWith(shadowForm.value))],
    //fields,
    [shadowForm as any as FormGroup<FormType<T>>]
  );
};

const getCompletionPercentage = <T = any>(
  progressList$: Observable<any>[],
  //fieldList: FormFieldList<T>,
  formList: FormGroup<FormType<T>>[]
) => {
  return combineLatest(progressList$).pipe(
    map((_) => calcTotFields(formList)),
    skipWhile((totFields) => totFields === 0),
    map((totFields) => {
      const totValidFields = calcTotValidFields(formList);
      const formCompletionPercentage = calcFormCompletionPercentage(
        totFields,
        totValidFields
      );
      return formCompletionPercentage;
    })
  );
};

const calcTotFields = <T = any>(forms: FormGroup<FormType<T>>[]) => {
  /* const totFields = fieldList
    .map((fields) => fields.length)
    .reduce((p, c) => p + c);
  return totFields; */
  const totFields = forms
    .map((form) => Object.keys(form.controls).length)
    .reduce((p, c) => p + c);
  return totFields;
};

const calcTotValidFields = <T = any>(forms: FormGroup[]) => {
  const totValidFields = forms
    .map((c) => {
      let ctrls = Object.values(c.controls);
      let validCtrls = ctrls.filter((ctrl) => !ctrl.invalid && !ctrl.pending);
      let validFieldsCount = validCtrls.length;
      return validFieldsCount;
    })
    .reduce((p, c) => p + c);
  return totValidFields;
};

const calcFormCompletionPercentage = <T = any>(
  totFields: number,
  totValidFields: number
) => {
  let ratio = totFields ? (totValidFields * 100) / totFields : 0;
  let rounded = Math.floor(ratio);
  return rounded;
};
